<script setup>
import * as echarts from 'echarts/core'
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  GraphicComponent,
} from 'echarts/components'
import { PieChart } from 'echarts/charts'
import { LabelLayout } from 'echarts/features'
import { CanvasRenderer } from 'echarts/renderers'
import { onMounted, ref } from 'vue'

echarts.use([
  TooltipComponent,
  TitleComponent,
  PieChart,
  CanvasRenderer,
  LabelLayout,
  LegendComponent,
  GridComponent,
  GraphicComponent,
])

const props = defineProps({
  // 配置项
  option: {
    type: Object,
    default: null,
  },
})

const pieRef = ref(null)
const myChart = ref()

defineExpose({
  // 重新渲染
  renderChart(option) {
    myChart.value && myChart.value.setOption(option)
  },
})

onMounted(() => {
  if (pieRef.value) {
    myChart.value = echarts.init(pieRef.value)
    props.option && myChart.value.setOption(props.option)
  }
})
</script>
<template>
  <div v-if="!option" class="pie-tips">Pie: 请传入option</div>
  <div v-else ref="pieRef" class="pie"></div>
</template>
<style lang="scss" scoped>
.pie-tips {
  font-size: 36px;
  text-align: center;
  color: red;
}
.pie {
  width: 700px;
  height: 600px;
  /* height: 100px; */
}
</style>
